// extracted by mini-css-extract-plugin
export default {"forgottenPasswordAnchor":"LoginForm_forgottenPasswordAnchor__6CL+F","errorHelperText":"LoginForm_errorHelperText__Tx2cw","submitButton":"LoginForm_submitButton__50on5"};